import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

export default function LoginCallback() {
  const auth = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (auth.isAuthenticated) nav('/', { replace: true });
  }, [auth.isAuthenticated, nav]);
  return <div className="container py-5">Completamento login…</div>;
}
